import VResizable from './VResizable'

export { VResizable }

export default VResizable